export const USERS_ACTIONS = {
    GET: 'GET_USERS',
    FIND: 'FIND_USERS',

    SUCCESS: 'SUCCESS_USERS',
    ERROR: 'ERROR_USERS',
    CLEAN: 'CLEAN_USERS',
}